import type { ExcludablePosition } from "../../lib/networth";

interface Props {
  positions: ExcludablePosition[];
  excludedIds: Set<string>;
  onToggle: (id: string) => void;
}

function formatEur(cents: number): string {
  return (cents / 100).toLocaleString("de-DE", { style: "currency", currency: "EUR" });
}

export function InclusionFilter({ positions, excludedIds, onToggle }: Props) {
  if (positions.length === 0) return null;
  const hiddenCount = excludedIds.size;
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs font-semibold" style={{ color: "var(--muted)" }}>
        Sonderpositionen:
      </span>
      {positions.map((pos) => {
        const isIncluded = !excludedIds.has(pos.id);
        const values = Object.values(pos.perStichtag);
        const latest = values.length > 0 ? (values[values.length - 1] ?? 0) : 0;
        return (
          <button
            key={pos.id}
            type="button"
            onClick={() => onToggle(pos.id)}
            className="px-2.5 py-1 text-xs rounded-md font-medium transition-colors"
            style={
              isIncluded
                ? { background: "var(--accent-soft)", color: "var(--accent)" }
                : {
                    background: "var(--card-elev)",
                    color: "var(--muted)",
                    textDecoration: "line-through",
                  }
            }
            title={
              isIncluded
                ? `Klick blendet ${pos.name} aus`
                : `Klick blendet ${pos.name} wieder ein`
            }
          >
            {isIncluded ? "✓" : "○"} {pos.name} ({formatEur(latest)})
          </button>
        );
      })}
      {hiddenCount > 0 && (
        <span className="text-xs" style={{ color: "var(--neg)" }}>
          {hiddenCount} ausgeblendet
        </span>
      )}
    </div>
  );
}
